$( window ).on("load", function() {
  $(".loader-container").fadeOut();
});


$( window ).on("load", function() {
  if ($(window).width() < 767){
    $( ".sbf-title" ).removeClass( "active" )
  }

});

document.documentElement.classList.add('js');

/// ----------------------------

$(document).ready(function(){

  const $rootSingle = $('.cSlider--single');
  const $rootNav = $('.cSlider--nav');

  $rootSingle.slick({
    slide: '.cSlider__item',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    adaptiveHeight: true,
    infinite: false,
    useTransform: true,
    speed: 400,
    cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
    autoplay: true,
    autoplaySpeed: 5000,
  });

  $rootNav.on('init', function(event, slick) {
    $(this).find('.slick-slide.slick-current').addClass('is-active');
  })
  .slick({
    slide: '.cSlider__item',
    slidesToShow: 5,
    slidesToScroll: 5,
    vertical: true,
    verticalSwiping: true,
    dots: false,
    arrows: false,
    focusOnSelect: false,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 5000,
  });

  $rootSingle.on('afterChange', function(event, slick, currentSlide) {
    $rootNav.slick('slickGoTo', currentSlide);
    $rootNav.find('.slick-slide.is-active').removeClass('is-active');
    $rootNav.find('.slick-slide[data-slick-index="' + currentSlide + '"]').addClass('is-active');
  });

  $rootNav.on('click', '.slick-slide', function(event) {
    event.preventDefault();
    var goToSingleSlide = $(this).data('slick-index');

    $rootSingle.slick('slickGoTo', goToSingleSlide);
  });




  // Select all links with hashes
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
});



$(window).scroll(function() {    
  var scroll = $(window).scrollTop();

  if (scroll >= 200) {
    $("#HeaderWrapper").addClass("sticky");
  } else {
    $("#HeaderWrapper").removeClass("sticky");
  }
});



$(document).ready(function() {
  $(".set > span.heading_clickable").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
      .siblings(".content")
      .slideUp(200);
      $(".set > span.heading_clickable i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
    } else {
      $(".set > span.heading_clickable i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
      $(this)
      .find("i")
      .removeClass("fa-plus")
      .addClass("fa-minus");
      $(".set > span.heading_clickable").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
      .siblings(".content")
      .slideDown(200);
    }
  });
  
  $('.custom_dropdown > span').click(function(){
    $(this).toggleClass('active');
  	$('.custom_dropdown ul').toggleClass('active');
  });
  
});


$(document).ready(function() {
  $('.size_cart_icon').click(function(){
    $('.chart_popup').addClass('active');
    $('body').addClass('overflow_hidden');
  });
  $('.popup_close').click(function(){
    $('.chart_popup').removeClass('active');
    $('body').removeClass('overflow_hidden');
  });
});


$(document).ready(function() {
  $('.moreless-button').click(function() {
    $('.moretext').slideToggle();
    $('.short_coll_desc').slideToggle();
    $('.collection-hero').toggleClass('expand');
    
    if ($('.moreless-button').text() == "Lees meer") {
      $(this).text("Lees minder")
    } else {
      $(this).text("Lees meer")
    }
  });
  
   $('.custom_filter h2.sb-title').click(function() {
      $('.custom_filter .sb-filter-wrapper').toggleClass('active_mob');
     $(this).toggleClass('active_label');
     });
  
  
  $('.site-nav__link.site-nav__link--icon.js-drawer-open-nav').click(function() {
    
    $('#localization_form').addClass('active');
    
    });
  
  
   $('.drawer__close-button.js-drawer-close').click(function() {
    
    $('#localization_form').removeClass('active');
    
    });
 
  
});